export default __webpack_public_path__ + "static/Vumography-BG3-64cd3c832722b1198494842c5de82c19.webp";